import React from 'react'

const CountQuestion = ({number}) => {
  return (
    <div className="flex items-center">
      <span className="w-48">Jumlah Soal</span>
      <span className="w-1/2">: <span className="font-semibold text-slate-900">{number}</span> Soal</span>
    </div>
  )
}

export default CountQuestion